import { Chart, registerables, TimeScale } from "chart.js";
import "chart.js/auto";
import "chartjs-adapter-date-fns";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { addYears, format } from "date-fns";
import { useRef } from "react";
import { Scatter } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

Chart.register(ChartDataLabels, TimeScale, ...registerables);

interface ScoreChartProps {
  total: number;
  score: number | null;
}

export default function ScoreChart({ total, score }: ScoreChartProps) {
  const { t } = useTranslation();
  const ref = useRef();

  const data = {
    datasets: [
      {
        label: "Scatter Dataset",
        data: [
          {
            x: format(new Date(), t("year-format")),
            y: score ?? 0,
          },
          ...Array(3)
            .fill(1)
            .map((_, i) => ({
              x: format(addYears(new Date(), i + 1), t("year-format")),
              y: 0,
            })),
        ],
        backgroundColor: "#0891B2",
        pointStyle: "rect",
        pointRadius: 6,
        pointHoverRadius: 6,
      },
    ],
  };

  return (
    <Scatter
      options={{
        maintainAspectRatio: false,
        layout: {
          padding: {},
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
          datalabels: {
            align: "right",
            formatter: function (value, context) {
              return value.y;
            },
            color: "#0891B2",
          },
        },
        scales: {
          x: {
            type: "time",
            time: {
              unit: "year",
              displayFormats: {
                year: t("year-format"),
              },
            },
          },
          y: {
            min: 0,
            max: total,
            ticks: {
              stepSize: total / 2,
            },
          },
        },
      }}
      ref={ref}
      data={data}
      id={"score-chart"}
    />
  );
}
